// extracted by mini-css-extract-plugin
export default {"aboutPage":"contactPage_aboutPage__QALCl"};